import React, { useState } from 'react';
import { BlobServiceClient } from '@azure/storage-blob';

// ✅ Just the token part (without leading '?')
const sasToken = "si=*&sv=2024-11-04&sr=c&sig=m%2BGKZyClHHVOlQ1QZAdZzFAyCRg%2Bwnyp%2BHrYHvNrJHY%3D";

// ✅ Your container name — make sure it's correct
const containerName = "baader-test"; // or "100001" if that's what you're using

// ✅ Only the account name (not full URL)
const storageAccountName = "softoopwsh";

const ImageUploader = () => {
  const [uploading, setUploading] = useState(false);
  const [uploadedUrl, setUploadedUrl] = useState(null);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setUploading(true);
    try {
      // ✅ Correct BlobServiceClient setup
      const blobServiceClient = new BlobServiceClient(
        `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`
      );

      const containerClient = blobServiceClient.getContainerClient(containerName);

      // Create a unique blob name (e.g., date-based)
      const blobName = `${Date.now()}_${file.name}`;
      const blockBlobClient = containerClient.getBlockBlobClient(blobName);

      await blockBlobClient.uploadBrowserData(file, {
        blobHTTPHeaders: { blobContentType: file.type },
      });

      const uploadedBlobUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${blobName}`;
      setUploadedUrl(uploadedBlobUrl);
      alert('Upload successful!');
    } catch (error) {
      console.error('Upload error:', error.message);
      alert('Upload failed');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <h3>Upload Image to Azure Blob</h3>
      <input type="file" onChange={handleFileChange} accept="image/*" />
      {uploading && <p>Uploading...</p>}
      {uploadedUrl && (
        <div>
          <p>Uploaded Image:</p>
          <img src={uploadedUrl} alt="Uploaded" style={{ width: 200 }} />
          <p><a href={uploadedUrl} target="_blank" rel="noopener noreferrer">{uploadedUrl}</a></p>
        </div>
      )}
    </div>
  );
};

export default ImageUploader;
